import { cn } from '@utils';
import './style.scss';

type CommonButtonProps = {
  type?: 'primary' | 'secondary' | 'tertiary';
  className?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  size?: 'small' | 'regular';
  children?: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
};

export const CommonButton = ({
  type = 'primary',
  className = '',
  onClick = () => {},
  icon = null,
  size = 'regular',
  children,
  loading,
  disabled,
}: CommonButtonProps) => (
  <button
    data-testid="common-button"
    onClick={onClick}
    className={cn(
      'common-button',
      [type, className, size],
      loading ? 'common-button--loading' : '',
    )}
    type="button"
    disabled={disabled}
  >
    {icon && (
      <span className="d-flex" data-testid="common-button__icon">
        {icon}
      </span>
    )}
    <span className="common-button__title">
      {children}
    </span>
  </button>
);
